
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';
import Input from '../../../components/base/Input';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    if (!phone || !password) {
      alert('يرجى إدخال رقم الهاتف وكلمة المرور');
      return;
    }

    setIsLoading(true);
    
    // Simulate login process
    setTimeout(() => {
      setIsLoading(false);
      // Navigate to home page after successful login
      navigate('/home');
    }, 1500);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
      <div className="bg-white rounded-2xl p-8 w-full max-w-sm shadow-lg">
        <div className="text-center mb-8">
          <div className="w-16 h-16 mx-auto bg-blue-600 rounded-full flex items-center justify-center mb-4">
            <span className="text-xl font-bold text-white" style={{ fontFamily: 'Pacifico, serif' }}>
              فَنَار
            </span>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">{t('login')}</h2>
          <p className="text-gray-600">مرحباً بك في تطبيق فَنَار</p>
        </div>

        <div className="space-y-6">
          <Input
            label={t('phone')}
            placeholder="05xxxxxxxx"
            value={phone}
            onChange={setPhone}
            type="tel"
            required
            icon={<i className="ri-phone-line"></i>}
          />
          
          <Input
            label={t('password')}
            placeholder="••••••••"
            value={password}
            onChange={setPassword}
            type="password"
            required
            icon={<i className="ri-lock-line"></i>}
          />

          <Button
            onClick={handleLogin}
            className="w-full"
            size="lg"
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                جاري تسجيل الدخول...
              </div>
            ) : (
              t('login')
            )}
          </Button>

          <div className="text-center">
            <button
              onClick={() => navigate('/auth/register')}
              className="text-blue-600 hover:text-blue-700 font-medium"
            >
              ليس لديك حساب؟ إنشاء حساب جديد
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
